var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"imarcGreeting__meta"},[_vm._v("\n    "+_vm._s(_vm.dateTime)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }